import { gql } from '@apollo/client'

const WHERE_TO_START_FRAGMENT = gql`
  fragment WhereToStartFragment on Dog {
    id
    name
    gender
    possessivePronoun
    caloriesFedByPlan: roundedPlanPortionInCalories(
      multipleOf: $caloriesMultipleOf
    )
  }
`

export default WHERE_TO_START_FRAGMENT
